export default "__VITE_ASSET__68b2302e__"